<div data-test-id="signin-callback-loading-indicator"  class="text-center pt-5 pb-5 loading-indicator">
  <app-spinner data-test-id="signin-callback-spinner"  class="app-spinner d-fixed"></app-spinner>
</div>
